import { SearchPerson } from 'shell/view-models/search-anpr';

export interface TransformFamilySearchProps {
  isNationalResearch?: boolean;
  fiscalCode?: string;
  idFamily?: string;
  codeIstat?: string;
}

export const transformFamilySearch = (values: TransformFamilySearchProps): SearchPerson => {
  const subjectData = { ...values };

  const transformedFilters: SearchPerson = {
    datiRichiesta: {
      ricercaNazionale: subjectData.isNationalResearch ? '1' : '0',
      // Fixed value for request family
      schedaAnagraficaRichiesta: '1',
      // Fixed value for request family
      datiAnagraficiRichiesti: ['02', '10', '21'],
    },
    criteriRicerca: {
      codiceFiscale: subjectData.fiscalCode || undefined,
      // Fixed value for request family
      tipoScheda: '1',
      idFamigliaConvivenzaComune: {
        idFamigliaConvivenza: subjectData.idFamily || '',
        idFamigliaConvivenzaComuneIstat: subjectData.codeIstat || '',
      },
    },
  };

  return transformedFilters;
};
